<!------------- ETC comments threads pops up ------------------>
	<div class="reject_popup" *ngIf="thread_msg !== null">
		<div class="reject_popup_wrapper">
			<div class="reject_popup_header">
				<h3>{{"RejectReason" | translate}}</h3><button class="pop_close" (click)="threadClose()"><i class="bi bi-x"></i></button>
			</div>
			<div class="reject_popup_body" *ngIf="thread_msg.length > 0; else noMsg">
				<ul>
					<li *ngFor="let msg of thread_msg" class="client asso">
						<h5>{{msg.modifyUserName}}<span>{{formatDateTime(msg.modifyDate)}}</span></h5>
						<p>{{msg.modifyComment}}</p>
					</li>
				</ul>
			</div>
			<ng-template #noMsg>
				<div class="reject_popup_body">
					<p>{{'NoComments' | translate}}</p>
				</div>

			</ng-template>
		
		</div>
		
	</div>

<!---------------------------- END ----------------------------->


<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			[(ngModel)]="selectedTimesheetId"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.timesheetId" [title]="getOptionTitle(date)">
					{{getYear(date.weekEnding)}} {{ "DDMONTH."+getMonth(date.weekEnding) | translate}} ({{date.companyName}})
				</option>
			</select>
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{timeSheetCmnData?.customerName}}</p>
		</div><!-- {{userCode}} -->
		<div class="summary col-auto">
			<h2>{{"MonthlySummary" | translate}} :</h2>
			<ul>
				<li>
					<p><strong>{{"REGULAR" | translate}} - </strong> <span>{{timeSheetTopPannel?.regular}}</span></p>
				</li>
				<li>
					<p><strong>{{"OVERTIME" | translate}} - </strong> <span>{{timeSheetTopPannel?.overtime}}</span></p>
				</li>
				<li>
					<p><strong>{{"MIDNIGHT" | translate}} - </strong> <span>{{timeSheetTopPannel?.midnightOvertime}}</span></p>
				</li>
				<li>
					<p><strong>{{"TOTAL" | translate}} - </strong> <span>{{timeSheetTopPannel?.total}}</span></p>
				</li>
			</ul>
		</div>
		</section>
</div>

<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper_timesheet">

	<div class="actio_button_area">
		<button class="butn save_entry btn" (click)="onSave()" [disabled]="archive || allApproved">{{'SAVE' | translate}}</button>
		<button type="button" type="button" class="butn cancel_entry btn" (click)="onCancel()" [disabled]="archive || allApproved">{{'CANCEL' | translate}}</button>
		<!--<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>-->
		<!-- <button class="butn log_entry btn">{{"LOG" | translate}}</button> -->
		 <a class="butn log_entry btn" [routerLink]="['/associate-time-log', timesheetIdOrg]">{{"LOG" | translate}}</a>
		 <a class="butn pdf_down btn" href="javascript:void(0)" (click)="dwnPdf(timesheetId)">{{"PDFDWNASC" | translate}}</a>
		 <a class="butn go_back btn" href="javascript:void(0)" (click)="goBack()">{{'Back' | translate}}</a>
	</div>
	<div class="save-toast" *ngIf="showSaveToast">
		<span>{{ "dataSaveSuccesMessage" | translate }}</span>
	</div>
	<div *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
            {{ dashboard_msg | translate}}
			  
			<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
			<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div *ngIf="dashboard_err_msg.length"
			class="alert alert-danger alert-dismissible timesheet-err"
			role="alert">

			<p *ngFor="let err of dashboard_err_msg" class="err-msg">
				<strong 
				(click)="scrollToRow(err.row)">{{ err.disDate }}:</strong> {{ "TimeSheetError."+err.message | translate}}
			</p>

			<button type="button"
					class="close"
					(click)="reset()"
					aria-label="Close">
			</button>
		</div>
	<div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<!--<li class="fix"><s>F</s><span>Fix</span></li>-->
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
	</div>
	<!--  ############### Data Table Start ################# -->
	<div class="time_sheet_table_wrapper">
		<!-- Table Heading Start -->
		<div class="timeSheet_row_heading timesheet-header">
            <section>
                <article>
                    <div class="tbl_date">{{"DATE" | translate}}</div>
                    <div class="tbl_approve">
                        <span>{{"SUBMIT" | translate}}</span>
                        <label class="switch">
							<input type="checkbox"
							[(ngModel)]="selectAll"
								[ngModelOptions]="{standalone: true}"
								(change)="toggleAllApprovals($event)"
								 [disabled]="archive">
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_status">{{"STATUS" | translate}}</div>
                    <div class="tbl_action">{{"EDIT" | translate}}</div>
                    <div class="tbl_start">{{"START" | translate}}</div>
                    <div class="tbl_finish">{{"FINISH" | translate}}</div>
                    <div class="tbl_break">{{"BREAK" | translate}}</div>
                    <div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
                    <div class="tbl_note">{{"NOTE" | translate}}</div>
                    <div class="tbl_home">{{"HOME" | translate}}</div>
                    <div class="tbl_exp">{{"EXPENSES" | translate}}</div>
                    <div class="tbl_amtExp">{{"AMOUNTOFEXPENSES" | translate}}</div>
					<div class="tbl_etc">{{"ETC" | translate}}</div>                    
                </article>
            </section>
        </div>
		<!-- Table Heading End -->
		<!-- Mobile Table Heading Start -->
		<div class="timeSheet_row_heading_mobile timesheet-header">
			<aside>
				<div class="tbl_nav">{{"EXPAND" | translate}}</div>
                <div class="tbl_approve">
                    <label class="switch">
						<input type="checkbox"
						[(ngModel)]="selectAll"
						[ngModelOptions]="{standalone: true}"
							(change)="toggleAllApprovals($event)"
							 [disabled]="archive">
						<span class="slider"></span>
					</label>
                </div>
				<div class="tbl_date">{{"DATE" | translate}}</div>
				<div class="tbl_status">{{"STATUS" | translate}}</div>
				<div class="tbl_home">{{"HOME" | translate}}</div>
				<div class="tbl_start">{{"START" | translate}}</div>
				<div class="tbl_finish">{{"FINISH" | translate}}</div>
				<div class="tbl_break">{{"BREAK" | translate}}</div>
				<div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
			</aside>
		</div>
		<!-- Mobile Table Heading End -->
		<!-- Table Data Start as loop-->
		 <div class="timeSheet_row {{item.statusClass}}" *ngFor="let item of timeSheetData; let i = index; trackBy: trackByTimesheetLineItemId" id="timeSheet_row_{{i}}"  [attr.data-row]="i">
            <section>
				<aside>
					<div class="tbl_nav"><button class="expand" [class.active]="expandedRowsButton[i]" (click)="toggleBelowRows(i)"></button></div>
					<div class="tbl_approve">
						<label class="switch" *ngIf="item.status <= 10">
							<input type="checkbox" 
							[(ngModel)]="item.markedForSubmit" 
							[ngModelOptions]="{standalone: true}" 
							class="chkStatus" (change)="chkSubmitCnt()" 
							[disabled]="archive" />
							<span class="slider"></span>
						</label>
					</div>
					<div class="tbl_date">
					<strong [class]="item.cssClass">{{ item.dayWeekDay }} ({{ item.dayWeekKey | translate }})</strong>
					</div>
					<div class="tbl_status">
					<dl><span>{{ item.statusKey | translate }}</span></dl>
					</div>
					<div class="tbl_home">
						<label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" (ngModelChange)="markDirty()" class="chkWhf" [ngModelOptions]="{standalone: true}" [disabled]="(item.isApproved && !item.isEditing) || item.noteId === 20 || item.noteId === 50">
							<span class="slider"></span>
						</label>
					</div>
					<div class="tbl_start">
						<p *ngIf="item.startTime">{{item.startTime}}</p>
					</div>
					<div class="tbl_finish">
						<p *ngIf="item.endTime">{{item.endTime}}</p>
					</div>
					<div class="tbl_break">
						<p>{{item.breakMinutes}}</p>
					</div>
					<div class="tbl_mnBreak">
						<p>{{item.midnightBreakMinutes}}</p>
					</div>
				</aside>
                <article [ngClass]="{ 'expanded': expandedRows[i] }">
					<div class="tbl_date">
						<strong [class]="item.cssClass">{{ item.dayWeekDay }} ({{ item.dayWeekKey | translate }})</strong>
					</div>
                    <div class="tbl_approve">
						<samp></samp>
                        <label class="switch" *ngIf="item.status <= 10">
						<input type="checkbox" 
						[(ngModel)]="item.markedForSubmit" 
						[ngModelOptions]="{standalone: true}" 
						class="chkStatus" (change)="chkSubmitCnt()" 
						[disabled]="archive" [attr.tabindex]="i * 20 + 1" />
						<span class="slider"></span>
						</label>
                        <button class="expanded-save" *ngIf="item.status <= 20 && !archive && expandedRows[i]" (click)="saveRowExpanded(i)">{{"SAVESUBMIT" | translate}}</button>
                    </div>
                    <div class="tbl_status">
						<samp>{{"STATUS" | translate}}</samp>
						<dl><span>{{ item.statusKey | translate }}</span></dl>
					</div>
                    <div class="tbl_action">
						<samp>{{"EDIT" | translate}}</samp>
                        <div class="reject_save">
							<button name="Edit" class="edit" (click)="editReject(i)" *ngIf="item.status == 30 && !item.isEditing" [disabled]="archive" title="{{ 'EDIT_TOOLTIP' | translate }}">{{"EDIT" | translate}}</button>
							<button type="button" name="cancel" class="cancel" (click)="cancelReject(i)" *ngIf="item.isEditing" title="{{ 'CANCEL_TOOLTIP' | translate }}">{{'CANCEL' | translate}}</button>
							<button type="button" name="save" class="save" (click)="saveReject(i)" *ngIf="item.isEditing" title="{{ 'SAVE_TOOLTIP' | translate }}">{{'SAVE' | translate}}</button>
							<span class="butn clear_row" *ngIf="item.status <= 20 && !item.isEditing" (click)="clearRow(i)" title="{{ 'LINECLEAR_TOOLTIP' | translate }}">{{'LINECLEAR' | translate}}</span>
							<button type="button" name="cancel_clear" class="expanded-cancel" *ngIf="item.status <= 20 && !item.isEditing" (click)="cancelRowExpanded(i)" title="{{ 'REVERT_TOOLTIP' | translate }}">{{'REVERT' | translate}}</button>
						</div>
                    </div>
                    <div class="tbl_start">
                        <samp>{{"START" | translate}}</samp>
						<app-time-picker 
						[invalid]="item.startInvalid ?? false"
						type="start" 
						[tabIndex]="i * 20 + 2"
						[hour]="item.startHour"
						[minute]="item.startMinute"
						(timeChange)="onTimeChange($event, item, 'start')"
						[hidden]="!(item.status <= 20 || item.isEditing)"
						>
						</app-time-picker>
						<p *ngIf="item.isApproved && !item.isEditing && item.startTime">{{item.startTime}}</p>
                    </div>
                    <div class="tbl_finish">
                        <samp>{{"FINISH" | translate}}</samp>
						<app-time-picker 
						type="end"
						[tabIndex]="i * 20 + 4"
						[invalid]="item.endInvalid ?? false"
						[hour]="item.endHour"
						[minute]="item.endMinute"
						(timeChange)="onTimeChange($event, item, 'end')"
						 [hidden]="!(item.status <= 20 || item.isEditing)"
						 >
						</app-time-picker>
						<p *ngIf="item.isApproved && !item.isEditing && item.endTime">{{item.endTime}}</p>
                    </div>
                    <div class="tbl_break">
                        <samp>{{"BREAK" | translate}}</samp>
						<input type="text" name="break_time" id="break_time_{{i}}" class="form-control break_time" 
						inputmode="numeric" maxlength="4"
						style="ime-mode: inactive;"
						[(ngModel)]="item.breakMinutes"
						(ngModelChange)="onBreakMinutesChange(item, $event)"
						[ngClass]="{'is-invalid': item.breakInvalid || item.breakFormatError}"
						*ngIf="item.status <= 20 || item.isEditing" 
						[tabIndex]="(item.status <= 20 || item.isEditing) ? (i * 20 + 6) : -1" />
						<small *ngIf="item.breakFormatError" class="text-danger" style="font-size:10px;">数字のみ</small>
						<p *ngIf="item.isApproved && !item.isEditing">{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <samp>{{"MIDNIGHTBREAK" | translate}}</samp>
                        <input type="text" name="mid_night_break" id="mid_night_break_{{i}}"
							class="form-control mid_night_break" 
							inputmode="numeric" maxlength="3"
							style="ime-mode: inactive;"
							[(ngModel)]="item.midnightBreakMinutes"
							(ngModelChange)="onMnBreakMinutesChange(item, $event)"
							[ngClass]="{'is-invalid': item.mnBreakFormatError}"
							[tabIndex]="i * 20 + 7"
					*ngIf="item.status <= 20 || item.isEditing" />
					<small *ngIf="item.mnBreakFormatError" class="text-danger" style="font-size:10px;">数字のみ</small>
					<p *ngIf="item.isApproved && !item.isEditing">{{item.midnightBreakMinutes}}</p>
                    </div>
                    <div class="tbl_note">
                        <samp>{{"NOTE" | translate}}</samp>
						<select class="form-select note" name="note" id="note_{{i}}" *ngIf="item.status <= 20 || item.isEditing" [(ngModel)]="item.noteId" (focus)="savePrevNote(i)" (change)="chkNote($event, i)" [tabIndex]="i * 20 + 8">
						<option *ngFor="let note of noteTypes" [value]="note.typeID">
						{{ getNote(note.typeID).noteKey | translate }}
					</option>
					</select>
					<p *ngIf="item.isApproved && !item.isEditing">{{getNote(item.noteId).noteKey | translate}}</p>
                    </div>
                    <div class="tbl_home">
                        <samp>{{"HOME" | translate}}</samp>
                        <label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" (ngModelChange)="markDirty()" class="chkWhf" [ngModelOptions]="{standalone: true}" [disabled]="(item.isApproved && !item.isEditing) || item.noteId === 20 || item.noteId === 50" [tabIndex]="i * 20 + 9">
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_exp">
                        <samp>{{"EXPENSES" | translate}}</samp>
						<select class="form-select expenses" id="expenses_{{i}}" name="expenses" *ngIf="item.status <= 20 || item.isEditing" [(ngModel)]="item.expenseId" (ngModelChange)="markDirty()" [tabIndex]="i * 20 + 10">
							<option *ngFor="let expenses of expensesTypes"  [value]="expenses.typeID">
							{{ getExpenses(expenses.typeID).expensesKey | translate }}
						</option>
					</select>
					<p *ngIf="item.isApproved && !item.isEditing">{{getExpenses(item.expenseId).expensesKey | translate}}</p>
                    </div>
                    <div class="tbl_amtExp">
                        <samp>{{"AMOUNTOFEXPENSES" | translate}}</samp>
                        <input type="text" name="cost" id="cost_{{i}}" class="form-control cost" inputmode="numeric" 
						oninput="this.value = this.value.replace(/[^0-9]/g, '')" 
						style="ime-mode: inactive;" 
						[(ngModel)]="item.cost"
						(ngModelChange)="markDirty()" 
						[ngClass]="{'is-invalid': item.costInvalid}"
						*ngIf="item.status <= 20 || item.isEditing"
						[tabIndex]="i * 20 + 11" />
						<p *ngIf="item.isApproved && !item.isEditing">{{item.cost}}</p>
                    </div>
					<div class="tbl_etc" *ngIf="!item.isEditing">
                        <samp>{{"ETC" | translate}}</samp>                        
						<span *ngIf="item.countEtcRemarks > 0" [ngClass]="'get_comment'" (click)="onRejectClick(item)">({{item.countEtcRemarks}})</span>
						<p *ngIf="!item.isEditing" 
						class="info" 
						data-bs-toggle="tooltip" 
						data-bs-placement="top" 
						[attr.title]="item.etcRemarks || 'No remark'"
							#tooltipEl>{{item.etcRemarks}}</p>
                    </div>
				<div class="tbl_etc tbl_etc--editing" *ngIf="item.isEditing">
					<samp>{{"ETC" | translate}}</samp>
					<span *ngIf="item.countEtcRemarks > 0" [ngClass]="'get_comment'" (click)="onRejectClick(item)">({{item.countEtcRemarks}})</span>
					<input type="text" name="etc" id="etc" class="form-control" [(ngModel)]="item.etcRemarks" (ngModelChange)="markDirty()" />
				</div>
                </article>
            </section>
        </div>
		<!-- Table Heading End as loop -->
	</div>
	
	<!--  ############### Data Table End ################# -->
	<div class="work_hour_info">
		<h6>{{"Contract" | translate}} -</h6>
		<span *ngIf="jobOrderData">{{"START" | translate}} {{ toTimeString(jobOrderData.WorkStartTime) }}</span><span *ngIf="jobOrderData">{{"FINISH" | translate}} {{ toTimeString(jobOrderData.WorkEndTime) }}</span><span *ngIf="jobOrderData">{{"BREAK" | translate}} {{jobOrderData.breakTime}}</span><span *ngIf="jobOrderData">{{"MIDNIGHTBREAK" | translate}} {{jobOrderData.midBreakTime}}</span>
	</div>
	<div class="time_sheet_comment">
		<h3>{{"CommentsRemarks" | translate}}</h3>
		<textarea *ngIf="timeSheetCmnData" class="form-control" id="floatingTextarea2" [(ngModel)]="timeSheetCmnData.comments" (ngModelChange)="markDirty()"
			style="height: 100px"></textarea>
	</div>
	<div class="actio_button_area">
		<button class="butn save_entry btn" (click)="onSave()" [disabled]="archive || allApproved">{{"SAVE" | translate}}</button>
		<button class="butn cancel_entry btn" (click)="onCancel()" [disabled]="archive || allApproved">{{"CANCEL" | translate}}</button>
		 <a class="butn log_entry btn" [routerLink]="['/associate-time-log', timesheetIdOrg]">{{"LOG" | translate}}</a>
	</div>
	<!--  ############### Row 1 End ################# -->
	<div class="training_entry_box">
		<h4>{{"EducationTrainingRecords" | translate}}</h4>
		<p>{{trainingCommentsDis}} &nbsp;</p>
	</div>
</div>
<!-- Modal for training_history Start-->
	<div class="modal fade" id="training_history_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true" style="display:none !important">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.TrainingHistory" | translate}}</h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="sub_header_block">
					<div class="col-auto">
						{{"TrainingHistoryHeading" | translate}}
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="trainingComments" (ngModelChange)="markDirty()"></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btntraining_history_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btntraining_history_popup">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveTraining()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for training_history End-->
<!--  ############### Middle Containt Area End ################# -->
  